var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat409(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_409"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_409",
    "data-name": 409,
    className: "cls-2",
    d: "M29.64,2.81c11.6-4.13,24.28,7,29.49,16.39,6.8,12.31-.77,19.57,6.55,32.77,4,7.17,13.22,11.84,16.19,19.83,2.92,7.83-1,18.18-7.47,23.14-8.7,6.66-19.7,1.64-26.88-5.17C38.3,81,32.77,68.21,26.73,57.21,19.41,43.9,8.11,10.49,29.64,2.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat409);
export default __webpack_public_path__ + "static/media/cat_409.5d8e574cdc7704161c8c88cf7488fe38.svg";
export { ForwardRef as ReactComponent };